module.exports = __webpack_public_path__ + "img/map.7be0cf36.webp";